"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Agent_1 = require("./core/Agent");
var Types = require("./types");
/**
 * Agent that works with Search Findify API endpoint
 */
var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    function Search() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = Types.RequestType.Search;
        return _this;
    }
    return Search;
}(Agent_1.Agent));
exports.Search = Search;
/**
 * Agent that works with Autocomplete Findify API endpoint
 */
var Autocomplete = /** @class */ (function (_super) {
    __extends(Autocomplete, _super);
    function Autocomplete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = Types.RequestType.Autocomplete;
        return _this;
    }
    return Autocomplete;
}(Agent_1.Agent));
exports.Autocomplete = Autocomplete;
/**
 * Agent that works with Recommendation Findify API endpoint
 */
var Recommendation = /** @class */ (function (_super) {
    __extends(Recommendation, _super);
    function Recommendation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = Types.RequestType.Recommendations;
        return _this;
    }
    return Recommendation;
}(Agent_1.Agent));
exports.Recommendation = Recommendation;
/**
 * Agent that works with Content Findify API endpoint
 */
var Content = /** @class */ (function (_super) {
    __extends(Content, _super);
    function Content() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = Types.RequestType.Content;
        return _this;
    }
    return Content;
}(Agent_1.Agent));
exports.Content = Content;
/**
 * Agent that works with Smart Collections Findify API endpoint
 */
var SmartCollection = /** @class */ (function (_super) {
    __extends(SmartCollection, _super);
    function SmartCollection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = Types.RequestType.SmartCollection;
        return _this;
    }
    return SmartCollection;
}(Agent_1.Agent));
exports.SmartCollection = SmartCollection;
//# sourceMappingURL=index.js.map